import type { LogAddinsCustomerContentParams } from "owa-analytics-types";
import { getAnalyticsAddon } from "owa-analytics-addons";

export function logAddinsCustomerContent(...args: LogAddinsCustomerContentParams): void {
    getAnalyticsAddon("LogAddinsTelemetryEvent")?.executeWhenReady(...args);
}
